import { render } from "./DeviceTable.vue?vue&type=template&id=0f7ed31c"
import script from "./DeviceTable.vue?vue&type=script&lang=js"
export * from "./DeviceTable.vue?vue&type=script&lang=js"

import "./DeviceTable.vue?vue&type=style&index=0&id=0f7ed31c&lang=css"

import exportComponent from "/home/salah/dev/yoda-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__